import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VideoService {
  private bitmovinKey = '7f4864c7-3ec3-4a8e-b6c6-8734c63a47ed'; 
  private videoUrl =
    'https://media.iexcel.academy/vizhubmedia/aha/cya/final/manifest.m3u8'; 
  private videoEndTime = 1123; // Replace with your video end time in seconds

  getBitmovinKey(): string {
    return this.bitmovinKey;
  }

  getVideoUrl(): string {
    return this.videoUrl;
  }

  getVideoEndTime(): number {
    return this.videoEndTime;
  }

  setVideoEndTime(time: number): void {
    this.videoEndTime = time;
  }

  setVideoUrl(url: string): void {
    this.videoUrl = url;
  }
}
